import {
  DependencyList, useEffect, useRef,
} from 'react';
import {
  ToastStatus,
  useToastNotifications,
} from '@equifinance/shared';

export function useToast(
  shouldShowNotification: boolean,
  message: string,
  deps?: DependencyList,
  toastStatus: ToastStatus = ToastStatus.SUCCESS,
) {
  const { addToastNotification } = useToastNotifications();
  const renderCount = useRef(0);

  useEffect(() => {
    renderCount.current += 1;

    const isDevelopment = process.env.NODE_ENV === 'development';
    const requiredRenderCount = isDevelopment ? 3 : 2;

    if (renderCount.current >= requiredRenderCount && shouldShowNotification) {
      addToastNotification({
        text: message,
        type: toastStatus,
        showCloseIcon: true,
      });

      renderCount.current = 0;
    }
  }, deps);
}
